(function () {
  if (window.__PNC_BOOTED__) return;
  window.__PNC_BOOTED__ = true;

  window.PNC = window.PNC || {};

  function mod(n, m) {
    return ((n % m) + m) % m;
  }

  function initPerfumeCarousel(root, force) {
    if (!root) return;
    if (root.__pncInitialized && !force) return;

    if (force && typeof root.__pncDestroy === "function") {
      root.__pncDestroy();
    }

    const sectionId = root.getAttribute("data-section-id");
    const carousel = root.querySelector("[data-perfume-carousel]");
    const viewport = root.querySelector("[data-viewport]");
    const sources = Array.from(root.querySelectorAll("[data-source-slide]"));
    const prevButton = root.querySelector("[data-prev]");
    const nextButton = root.querySelector("[data-next]");

    const infoName = root.querySelector("[data-info-name]");
    const infoType = root.querySelector("[data-info-type]");
    const infoVolume = root.querySelector("[data-info-volume]");
    const infoProduct = root.querySelector("[data-info-product]");

    const noteButtons = Array.from(
      root.querySelectorAll("[data-note-index]")
    );

    /*
      IMPORTANT
      각 블록의 데이터 저장용:
      data-note-text="..."

      실제 화면 출력용:
      data-note-output

      둘을 분리해서 selector 충돌 방지.
    */
    const noteText = root.querySelector("[data-note-output]");

    const activeLink = root.querySelector("[data-active-link]");

    const slotFarPrev = root.querySelector(
      '[data-slot="far-prev"]'
    );
    const slotPrev = root.querySelector(
      '[data-slot="prev"]'
    );
    const slotActive = root.querySelector(
      '[data-slot="active"]'
    );
    const slotNext = root.querySelector(
      '[data-slot="next"]'
    );
    const slotFarNext = root.querySelector(
      '[data-slot="far-next"]'
    );
    const slotGhostLeft = root.querySelector(
      '[data-slot="ghost-left"]'
    );
    const slotGhostRight = root.querySelector(
      '[data-slot="ghost-right"]'
    );

    if (
      !sectionId ||
      !carousel ||
      !viewport ||
      !sources.length ||
      !slotFarPrev ||
      !slotPrev ||
      !slotActive ||
      !slotNext ||
      !slotFarNext ||
      !slotGhostLeft ||
      !slotGhostRight
    ) {
      return;
    }

    /*
      재초기화 시 현재 슬라이드 위치 유지.
      기존 코드의 let currentIndex = 0; 때문에
      테마 에디터 이벤트 발생 시 첫 블록으로 되돌아가던 문제 수정.
    */
    let currentIndex = Number(
      root.dataset.pncCurrentIndex || 0
    );

    if (
      Number.isNaN(currentIndex) ||
      currentIndex < 0 ||
      currentIndex >= sources.length
    ) {
      currentIndex = 0;
    }

    let isAnimating = false;

    let isPointerDown = false;
    let pointerId = null;
    let startX = 0;
    let startY = 0;

    let touchStartX = 0;
    let touchStartY = 0;

    let wheelLock = false;
    let wheelTimer = null;
    let animationTimer = null;

    const swipeThreshold = 36;
    const wheelThreshold = 12;
    const transitionMs = 320;
    const wheelLockMs = 240;

    function saveCurrentIndex() {
      root.dataset.pncCurrentIndex = String(currentIndex);
    }

    function setText(el, value) {
      if (el) {
        el.textContent = value || "";
      }
    }

    function getSource(index) {
      return sources[mod(index, sources.length)];
    }

    function isFromActiveLink(target) {
      return !!(
        target &&
        target.closest &&
        target.closest("[data-active-link]")
      );
    }

    function onActiveLinkPointerDown(e) {
      e.stopPropagation();
    }

    function onActiveLinkClick(e) {
      const href =
        activeLink &&
        activeLink.getAttribute("href");

      if (!href || href === "#") {
        e.preventDefault();
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      window.location.assign(href);
    }

    function applyImage(slot, source) {
      if (!slot || !source) return;

      const img = slot.querySelector(
        "[data-slot-img]"
      );

      if (!img) return;

      const imageUrl =
        source.dataset.imageUrl || "";

      const imageAlt =
        source.dataset.imageAlt || "";

      if (imageUrl) {
        img.src = imageUrl;
        img.alt = imageAlt;
        img.draggable = false;

        slot.classList.remove("is-empty");
      } else {
        img.removeAttribute("src");
        img.removeAttribute("srcset");
        img.alt = "";

        slot.classList.add("is-empty");
      }
    }

    function clearImage(slot) {
      if (!slot) return;

      const img = slot.querySelector(
        "[data-slot-img]"
      );

      if (!img) return;

      img.removeAttribute("src");
      img.removeAttribute("srcset");
      img.alt = "";

      slot.classList.add("is-empty");
    }

    function updateInfo(source) {
      if (!source) return;

      setText(
        infoName,
        source.dataset.perfumeName || ""
      );

      setText(
        infoType,
        source.dataset.perfumeType || ""
      );

      setText(
        infoVolume,
        source.dataset.perfumeVolume || ""
      );

      setText(
        infoProduct,
        source.dataset.productName || ""
      );

      /*
        현재 활성 향수 블록의
        Text below note buttons 값 출력
      */
      setText(
        noteText,
        source.dataset.noteText || ""
      );

      noteButtons.forEach(function (button) {
        const idx =
          button.dataset.noteIndex;

        const isActive =
          source.getAttribute(
            "data-note-" + idx
          ) === "1";

        button.classList.toggle(
          "is-active",
          isActive
        );
      });

      if (activeLink) {
        const productLink =
          source.dataset.productLink || "";

        if (productLink) {
          activeLink.href = productLink;

          activeLink.classList.remove(
            "is-disabled"
          );

          activeLink.setAttribute(
            "aria-label",
            source.dataset.imageAlt ||
              source.dataset.perfumeName ||
              "Open product"
          );
        } else {
          activeLink.href = "#";

          activeLink.classList.add(
            "is-disabled"
          );

          activeLink.setAttribute(
            "aria-label",
            "Product link unavailable"
          );
        }
      }
    }

    function render() {
      saveCurrentIndex();

      applyImage(
        slotFarPrev,
        getSource(currentIndex - 2)
      );

      applyImage(
        slotPrev,
        getSource(currentIndex - 1)
      );

      applyImage(
        slotActive,
        getSource(currentIndex)
      );

      applyImage(
        slotNext,
        getSource(currentIndex + 1)
      );

      applyImage(
        slotFarNext,
        getSource(currentIndex + 2)
      );

      clearImage(slotGhostLeft);
      clearImage(slotGhostRight);

      updateInfo(
        getSource(currentIndex)
      );
    }

    function cleanupAnimationClasses() {
      viewport.classList.remove(
        "is-animating",
        "is-animating-next",
        "is-animating-prev"
      );

      slotGhostLeft.classList.remove(
        "is-entering"
      );

      slotGhostRight.classList.remove(
        "is-entering"
      );
    }

    function finishAnimation(nextIndex) {
      currentIndex = mod(
        nextIndex,
        sources.length
      );

      saveCurrentIndex();

      viewport.classList.add(
        "is-resetting"
      );

      cleanupAnimationClasses();

      render();

      void viewport.offsetWidth;

      viewport.classList.remove(
        "is-resetting"
      );

      isAnimating = false;
      animationTimer = null;
    }

    function animate(direction) {
      if (
        isAnimating ||
        sources.length < 2
      ) {
        return;
      }

      isAnimating = true;

      clearTimeout(animationTimer);
      cleanupAnimationClasses();

      if (direction > 0) {
        applyImage(
          slotGhostRight,
          getSource(currentIndex + 3)
        );

        slotGhostRight.classList.add(
          "is-entering"
        );

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            viewport.classList.add(
              "is-animating",
              "is-animating-next"
            );
          });
        });

        animationTimer =
          setTimeout(function () {
            finishAnimation(
              currentIndex + 1
            );
          }, transitionMs + 30);
      } else {
        applyImage(
          slotGhostLeft,
          getSource(currentIndex - 3)
        );

        slotGhostLeft.classList.add(
          "is-entering"
        );

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            viewport.classList.add(
              "is-animating",
              "is-animating-prev"
            );
          });
        });

        animationTimer =
          setTimeout(function () {
            finishAnimation(
              currentIndex - 1
            );
          }, transitionMs + 30);
      }
    }

    function goTo(index) {
      currentIndex = mod(
        index,
        sources.length
      );

      saveCurrentIndex();

      viewport.classList.add(
        "is-resetting"
      );

      cleanupAnimationClasses();

      render();

      void viewport.offsetWidth;

      viewport.classList.remove(
        "is-resetting"
      );
    }

    function prev() {
      animate(-1);
    }

    function next() {
      animate(1);
    }

    function lockWheel() {
      wheelLock = true;

      clearTimeout(wheelTimer);

      wheelTimer =
        setTimeout(function () {
          wheelLock = false;
        }, wheelLockMs);
    }

    function onPrevClick(e) {
      e.preventDefault();
      e.stopPropagation();

      prev();
    }

    function onNextClick(e) {
      e.preventDefault();
      e.stopPropagation();

      next();
    }

    function onKeydown(e) {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        prev();
      } else if (
        e.key === "ArrowRight"
      ) {
        e.preventDefault();
        next();
      }
    }

    function resetPointerState() {
      isPointerDown = false;
      pointerId = null;

      viewport.classList.remove(
        "is-dragging"
      );
    }

    function onPointerDown(e) {
      if (
        isFromActiveLink(e.target)
      ) {
        return;
      }

      if (
        e.pointerType === "mouse" &&
        e.button !== 0
      ) {
        return;
      }

      isPointerDown = true;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;

      viewport.classList.add(
        "is-dragging"
      );

      if (
        viewport.setPointerCapture &&
        pointerId !== null
      ) {
        try {
          viewport.setPointerCapture(
            pointerId
          );
        } catch (error) {}
      }
    }

    function onPointerUp(e) {
      if (!isPointerDown) return;

      if (
        pointerId !== null &&
        e.pointerId !== pointerId
      ) {
        return;
      }

      const diffX =
        e.clientX - startX;

      const diffY =
        e.clientY - startY;

      resetPointerState();

      if (
        Math.abs(diffX) >
          swipeThreshold &&
        Math.abs(diffX) >
          Math.abs(diffY)
      ) {
        e.preventDefault();

        if (diffX > 0) {
          prev();
        } else {
          next();
        }
      }
    }

    function onPointerCancel() {
      resetPointerState();
    }

    function onTouchStart(e) {
      if (
        isFromActiveLink(e.target)
      ) {
        return;
      }

      if (
        !e.touches ||
        !e.touches.length
      ) {
        return;
      }

      touchStartX =
        e.touches[0].clientX;

      touchStartY =
        e.touches[0].clientY;
    }

    function onTouchEnd(e) {
      if (
        !e.changedTouches ||
        !e.changedTouches.length
      ) {
        return;
      }

      const diffX =
        e.changedTouches[0].clientX -
        touchStartX;

      const diffY =
        e.changedTouches[0].clientY -
        touchStartY;

      if (
        Math.abs(diffX) >
          swipeThreshold &&
        Math.abs(diffX) >
          Math.abs(diffY)
      ) {
        if (diffX > 0) {
          prev();
        } else {
          next();
        }
      }
    }

    function onWheel(e) {
      if (
        wheelLock ||
        isAnimating ||
        sources.length < 2
      ) {
        return;
      }

      const absX =
        Math.abs(e.deltaX);

      const absY =
        Math.abs(e.deltaY);

      if (
        absX <= absY ||
        absX < wheelThreshold
      ) {
        return;
      }

      lockWheel();

      if (e.deltaX > 0) {
        next();
      } else {
        prev();
      }
    }

    function onBlockSelect(e) {
      const blockId =
        e.detail &&
        e.detail.blockId;

      if (!blockId) return;

      const selectedBlock =
        sources.find(
          function (item) {
            return (
              item.getAttribute(
                "data-block-id"
              ) === blockId
            );
          }
        );

      if (!selectedBlock) return;

      const selectedIndex =
        Number(
          selectedBlock.dataset.index
        );

      if (
        Number.isNaN(
          selectedIndex
        )
      ) {
        return;
      }

      goTo(selectedIndex);
    }

    /*
      EVENTS
    */

    if (prevButton) {
      prevButton.addEventListener(
        "click",
        onPrevClick
      );
    }

    if (nextButton) {
      nextButton.addEventListener(
        "click",
        onNextClick
      );
    }

    if (activeLink) {
      activeLink.addEventListener(
        "pointerdown",
        onActiveLinkPointerDown
      );

      activeLink.addEventListener(
        "click",
        onActiveLinkClick
      );
    }

    carousel.addEventListener(
      "keydown",
      onKeydown
    );

    viewport.addEventListener(
      "pointerdown",
      onPointerDown
    );

    viewport.addEventListener(
      "pointerup",
      onPointerUp
    );

    viewport.addEventListener(
      "pointercancel",
      onPointerCancel
    );

    viewport.addEventListener(
      "lostpointercapture",
      onPointerCancel
    );

    viewport.addEventListener(
      "touchstart",
      onTouchStart,
      { passive: true }
    );

    viewport.addEventListener(
      "touchend",
      onTouchEnd,
      { passive: true }
    );

    viewport.addEventListener(
      "wheel",
      onWheel,
      { passive: true }
    );

    document.addEventListener(
      "shopify:block:select",
      onBlockSelect
    );

    /*
      DESTROY
    */

    root.__pncDestroy =
      function () {
        if (prevButton) {
          prevButton.removeEventListener(
            "click",
            onPrevClick
          );
        }

        if (nextButton) {
          nextButton.removeEventListener(
            "click",
            onNextClick
          );
        }

        if (activeLink) {
          activeLink.removeEventListener(
            "pointerdown",
            onActiveLinkPointerDown
          );

          activeLink.removeEventListener(
            "click",
            onActiveLinkClick
          );
        }

        carousel.removeEventListener(
          "keydown",
          onKeydown
        );

        viewport.removeEventListener(
          "pointerdown",
          onPointerDown
        );

        viewport.removeEventListener(
          "pointerup",
          onPointerUp
        );

        viewport.removeEventListener(
          "pointercancel",
          onPointerCancel
        );

        viewport.removeEventListener(
          "lostpointercapture",
          onPointerCancel
        );

        viewport.removeEventListener(
          "touchstart",
          onTouchStart
        );

        viewport.removeEventListener(
          "touchend",
          onTouchEnd
        );

        viewport.removeEventListener(
          "wheel",
          onWheel
        );

        document.removeEventListener(
          "shopify:block:select",
          onBlockSelect
        );

        clearTimeout(
          wheelTimer
        );

        clearTimeout(
          animationTimer
        );

        cleanupAnimationClasses();

        root.__pncInitialized =
          false;

        delete root.__pncDestroy;
      };

    root.__pncInitialized = true;

    /*
      EXTERNAL API
    */

    window.PNC[sectionId] = {
      prev: prev,
      next: next,
      goTo: goTo,
      render: render
    };

    render();
  }

  function bootAllCarousels(
    force
  ) {
    document
      .querySelectorAll(
        '[id^="PerfumeNoteCarousel-"]'
      )
      .forEach(
        function (root) {
          initPerfumeCarousel(
            root,
            force
          );
        }
      );
  }

  /*
    기존에는 여기서 true로
    여러 번 강제 초기화하면서
    currentIndex 및 블록 상태가 되돌아가는 문제가 있었음.

    이제 이미 초기화된 캐러셀은 건드리지 않는다.
  */
  function scheduleBoot() {
    bootAllCarousels(false);

    setTimeout(
      function () {
        bootAllCarousels(false);
      },
      120
    );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      scheduleBoot
    );
  } else {
    scheduleBoot();
  }

  window.addEventListener(
    "load",
    scheduleBoot
  );

  document.addEventListener(
    "shopify:section:load",
    scheduleBoot
  );

  document.addEventListener(
    "shopify:section:reorder",
    scheduleBoot
  );

  document.addEventListener(
    "shopify:section:select",
    scheduleBoot
  );

  /*
    Shopify Theme Editor가 DOM을 갈아끼우는 경우
    새로 생긴 섹션만 초기화.
    기존 섹션은 재초기화하지 않음.
  */
  const observer =
    new MutationObserver(
      function () {
        bootAllCarousels(false);
      }
    );

  function startObserver() {
    if (!document.body) return;

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (document.body) {
    startObserver();
  } else {
    window.addEventListener(
      "load",
      startObserver
    );
  }
})();